import React from "react";
import { Link } from "react-router-dom";

import TableV2 from "src/components/ui/TableV2";
import { formatDateTime } from "src/utils/date-time";
import { currencyFormatter } from "src/utils/common";
import { ITenantRecentPurchaseOrder } from "src/types/dashboard.types";

interface RecentPurchaseTableProps {
  rows: ITenantRecentPurchaseOrder[];
}

const RecentPurchaseTable: React.FC<RecentPurchaseTableProps> = ({ rows }) => {
  return (
    <TableV2
      columns={[
        {
          key: "purchaseOrderId",
          header: "Order",
          accessor: ({ row }) => (
            <Link to={`/app/purchase/${row._id}`} className="text-primary-600">
              {row.purchaseOrderId}
            </Link>
          ),
        },
        {
          key: "supplier",
          header: "Supplier",
          accessor: ({ row }) => row.supplierId?.name || "-",
        },
        {
          key: "grandTotal",
          header: "Total",
          align: "right",
          accessor: ({ row }) => currencyFormatter(row.grandTotal || 0),
        },
        {
          key: "createdAt",
          header: "Date",
          align: "center",
          accessor: ({ row }) =>
            formatDateTime(row.createdAt, "DD/MM/YYYY hh:mm:ss A"),
        },
      ]}
      data={rows}
    />
  );
};

export default RecentPurchaseTable;
